import { ReactNode } from 'react';

export type InputRangeType = {
  max?: number;
  min?: number;
  value: number;
  onChange: (val) => void;
  suffix?: ReactNode;
  showValue?: boolean;
};

const InputRange = ({
  showValue = true,
  max = 25,
  min = 1,
  value,
  onChange,
  suffix = 'SOL',
}: InputRangeType) => {
  const progress = ((value - min) / (max - min)) * 100;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = Number(event.target.value);
    onChange(newValue);
  };

  return (
    <div className="flex w-full m-auto items-center h-20 justify-center">
      <div className="py-1 relative min-w-full">
        <div className="h-2 bg-[#1A1C28] rounded-[2px] relative">
          {/* Progress Bar */}
          <div
            className="absolute h-2 rounded-full bg-[#E4775D]"
            style={{ width: `${progress}%` }}
          ></div>

          {/* Slider Thumb */}
          <div
            className="absolute h-7 flex items-center justify-center w-7 rounded-full bg-[#E4775D] shadow border-4 border-[#13141D] -ml-2 top-1/2 -translate-y-1/2 cursor-pointer"
            unselectable="on"
            style={{ left: `${progress}%` }}
          >
            {showValue && (
              <div className="relative -mt-2 w-1">
                <div className="absolute z-40 opacity-100 bottom-100 mb-2 -translate-x-1/2 min-w-full">
                  <div className="relative shadow-md">
                    <div className="bg-[#30344A] text-[#FCFCFC] -mt-12 truncate text-xs rounded p-2">
                      {value} {suffix}
                    </div>
                    <svg
                      className="absolute text-[#30344A] w-full h-2 left-0 top-100"
                      x="0px"
                      y="0px"
                      viewBox="0 0 255 255"
                      xmlSpace="preserve"
                    >
                      <polygon
                        className="fill-current"
                        points="0,0 127.5,127.5 255,0"
                      ></polygon>
                    </svg>
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Min and Max Labels */}
          <div className="absolute text-[#9192A0] text-[12px] bottom-0 left-0 -mb-6">
            {min} SOL
          </div>
          <div className="absolute text-[#9192A0] text-[12px] bottom-0 right-0 -mb-6">
            {max} SOL
          </div>
        </div>

        {/* Range Input (Hidden but Functional) */}
        <input
          type="range"
          className="absolute inset-0 opacity-0 w-full cursor-pointer"
          min={min}
          max={max}
          value={value}
          onChange={handleChange}
        />
      </div>
    </div>
  );
};

export default InputRange;
